import { useState, useEffect } from 'react';

import useGetSubsetFacts from '@/api/queries/useGetSubsetFacts';

export const useIncludedFacts = (matterId: string, subsetId: string, isOpen: boolean) => {
  const { data: factsResponse } = useGetSubsetFacts({
    matterId,
    subsetId,
    searchQuery: '',
    page: 1,
    pageSize: 1000,
    paginated: false,
    filters: {
      included: true,
    },
  });

  const facts = factsResponse?.facts || [];
  const [currentFactIndex, setCurrentFactIndex] = useState(0);

  // Reset current index when modal opens
  useEffect(() => {
    if (isOpen) {
      setCurrentFactIndex(0);
    }
  }, [isOpen]);

  // Ensure currentFactIndex is within bounds
  useEffect(() => {
    if (facts.length > 0 && currentFactIndex >= facts.length) {
      setCurrentFactIndex(0);
    }
  }, [facts.length, currentFactIndex]);

  const handlePrevFact = () => {
    setCurrentFactIndex((prev) => Math.max(0, prev - 1));
  };

  const handleNextFact = () => {
    setCurrentFactIndex((prev) => Math.min(facts.length - 1, prev + 1));
  };

  return {
    facts,
    currentFactIndex,
    currentFact: facts[currentFactIndex],
    handlePrevFact,
    handleNextFact,
  };
};
